import React from 'react';

const Vue_VOn = () => {
  return (
    <div>
      <h1>Vue_VOn Component</h1>
      <p>This is the Vue_VOn tutorial page.</p>
    </div>
  );
}

export default Vue_VOn;
